<template>
  <main>
    <payment-loading v-if="isLoading"/>
    <div v-else>
      <error-data v-if="isErrorDataSet"/>
    </div>
  </main>
</template>

<script>
import PaymentLoading from '@/base/components/Payment/Loader/Loading'
import ErrorData from '@/base/components/Error/Data'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { DateClass } from '@/base/class/date.class'
import viewMixin from '@/base/mixins/view.mixin'
import { pageTitle } from '@/base/const/routing.const'
import { MatomoClass } from '@/base/class/matomo.class'
import { MATOMO_EVENT_CATEGORY, MATOMO_EVENT_TYPE, MATOMO_VIEW_ACTION } from '@/base/const/matomo.const'

export default {
  name: 'Wait',
  metaInfo () {
    return {
      title: pageTitle().base,
      titleTemplate: '%s | ' + pageTitle().wait
    }
  },
  mixins: [viewMixin],
  components: {
    PaymentLoading,
    ErrorData
  },
  props: {
    idTransRemote: {
      type: String,
      required: true
    },
    apiToken: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState({
      paymentLoading: state => state.payment.loading,
      langLoading: state => state.lang.loading,
      paymentData: state => state.payment.paymentData
    }),
    ...mapGetters({
      isErrorDataSet: 'isErrorDataSet'
    }),
    isLoading () {
      return this.paymentLoading || this.langLoading || (!this.paymentData && !this.isErrorDataSet)
    }
  },
  methods: {
    ...mapMutations([
      'SET_ERROR_DATA',
      'SET_TIMER_TRX_GET_START',
      'SET_TIMER_TRX_START_LOADED'
    ]),
    ...mapActions([
      'getPaymentWaitData'
    ])
  },
  mounted () {
    MatomoClass.sendEvent([MATOMO_EVENT_TYPE.trackEvent, MATOMO_EVENT_CATEGORY.view, MATOMO_VIEW_ACTION.waitBlik])
    const data = {
      idTransRemote: this.idTransRemote,
      apiToken: this.apiToken
    }
    this.SET_TIMER_TRX_GET_START(DateClass.getCurrentTimestamp())
    this.getPaymentWaitData(data)
      .finally(() => {
        this.SET_TIMER_TRX_START_LOADED(DateClass.getCurrentTimestamp())
      })
      .catch(error => {
        // przekierowanie na potykacz PISowy jeśli nie ma danych psd2 dla startu WL z kanałem PISowym
        if (error.message === 'psd2Data') {
          this.$router.push({ name: 'RegulationsApprovalStart', params: { apiToken: this.apiToken } })
          return
        }
        this.SET_ERROR_DATA({
          errorCode: error.body.errorCode,
          errorUrl: error.body.errorUrl
        })
      })
  }
}
</script>
